import { TiposDeMovimentoRelatorio } from '../relatorio/opcoes-relatorio.interface'

export const TIPOS_DE_MOVIMENTO = [
    { tipo: TiposDeMovimentoRelatorio.Vendas, descricao: 'Minhas Vendas' },
    { tipo: TiposDeMovimentoRelatorio.Recebimentos, descricao: 'Meus recebimentos' },
    { tipo: TiposDeMovimentoRelatorio.Antecipacoes, descricao: 'Minhas antecipações' }
]



// WEBPACK FOOTER //
// ./src/app/extratos/shared/tipos-de-movimento.const.ts